export enum TimeNoticeCardColor {
  Default = 'default',
  Primary = 'primary',
  Red = 'red',
  Blue = 'blue',
  Green = 'green',
  Orange = 'orange',
  Gold = 'gold',
  Cyan = 'cyan',
  Purple = 'purple',
  Magenta = 'magenta',
  Lime = 'lime',
}
